import { createIcon } from '@consta/icons/Icon'
import type { SVGProps } from 'react'

import { getColorVariable } from './constants'

function IconColoredMarkerS(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect x="4" y="2" width="2" height="12" rx="1" fill={getColorVariable()} />
      <rect x="3" y="7" width="4" height="2" rx="1" fill="var(--color-typo-primary)" />
      <rect x="10" y="2" width="2" height="12" rx="1" fill={getColorVariable()} />
      <rect x="9" y="4" width="4" height="2" rx="1" fill="var(--color-typo-primary)" />
      <rect x="9" y="10" width="4" height="2" rx="1" fill="var(--color-typo-primary)" />
    </svg>
  )
}

export const IconColoredMarker = createIcon({
  l: IconColoredMarkerS,
  m: IconColoredMarkerS,
  s: IconColoredMarkerS,
  xs: IconColoredMarkerS,
  name: 'IconColoredMarker',
})
